import styled from 'styled-components';

const SCHideForMobile = styled.div`
  @media (max-width: 1000px) {
    display: none !important;
  }
`;

export default SCHideForMobile;
